import { Component, Input, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { WTableCommandLinkComponent } from './w-table-command-link.component';
import { RouterModule } from '@angular/router';
import { WDropdownModule } from '@wipo/w-angular/w-dropdown';



@Component({
    selector: 'w-table-commands',
    templateUrl: './w-table-commands.component.html',
    host: {
      class: 'b-table-commands',
        '[class.b-workbench-commands]': 'true',
        '[class.b-workbench-commands-dropdowns]': 'dropdowns'
    },
    standalone: false
})
/*
@id w-table-commands
@name w-table-commands
@status release
@description
*/
export class WTableCommandsComponent {
  @Input() dropdowns = false; // show links as dropdowns
}
@NgModule({
  imports: [CommonModule, RouterModule, WDropdownModule],
  exports: [WTableCommandsComponent, WTableCommandLinkComponent],
  declarations: [WTableCommandsComponent, WTableCommandLinkComponent]
})
export class WTableCommandsModule { }
